import { render, staticRenderFns } from "./ModalCustomerEmailTemplate.vue?vue&type=template&id=e93f1830"
import script from "./ModalCustomerEmailTemplate.vue?vue&type=script&lang=js"
export * from "./ModalCustomerEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports